export default {
    select: "Selecteer Verzendadres",
    shippingRulesTip: "U moet uw lokale regels voor verzending volgen"
}